import React, { DetailedHTMLProps, SelectHTMLAttributes } from "react";
import Select, { components } from "react-select";
import { FixedSizeList as List } from "react-window";

const CustomMenuList = (props) => {
  const itemHeight = 35;
  const { options, children, maxHeight, getValue, setValue } = props;
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * itemHeight;
  const height = Math.min(children.length * itemHeight, 300);
  return (
    <div>
      <List
        height={height}
        itemCount={children.length}
        itemSize={itemHeight}
        initialScrollOffset={initialOffset}
      >
        {({ index, style }) => (
          <div style={style}>
            <div className="flex items-center space-x-2 z-40 ">
              <input
                className={`flex items-center space-x-2 hover:bg-white ${
                  children[index].props.isSelected ? "" : "hidden"
                }`}
                type="checkbox"
                checked={children[index].props.isSelected ? true : false}
                onChange={() => null}
              />
              {children[index]}
            </div>
          </div>
        )}
      </List>
    </div>
  );
};

const customStyles = {
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#666",
    ":hover": {
      backgroundColor: "#999",
      color: "white",
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#e0e4e7",
    borderRadius: "2px",
    display: "flex",
    alignItems: "center",
    padding: "0 5px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#333",
  }),
  option: (provided, state) => ({
    ...provided,
    active: "",
    padding: "3px",
    color: "black",
    backgroundColor: "white",
    fontSize: "12px",
  }),
  control: (provided, state) => ({
    ...provided,
    background: "#fff",
    border: "0",
    boxShadow: state.isFocused ? null : null,
    minHeight: "26px",
    height: "auto",
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    height: "auto",
    minHeight: "26px",
    maxHeight: "90px", // Adjust the max height to your requirement
    overflowY: "auto",
    padding: "0px 6px",
    display: "flex",
    flexWrap: "wrap",
  }),
  input: (provided, state) => ({
    ...provided,
    margin: "0px",
  }),

  menu: (provided, state) => ({
    ...provided,
    overflowX: "auto",
    paddingLeft: "10px",
    height: "max",
  }),
};

const valueContainer = ({ children, ...props }) => {
  let [values, input] = children;

  if (Array.isArray(values)) {
    values =
      values.length > 1
        ? values.length === props.options.length
          ? "ALL"
          : values
        : values;
  } else {
    values =
      input.props?.value?.length > 0 ? values : "Select multiple options...";
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};

interface ISelectHookForm {
  field?: any;
  options: any[];
  isDisabled?: boolean;
  isRequired?: boolean;
  className?: string;
  label?: string;
  isMulti?: boolean;
  onChange?: any;
  value?: any;
  isLoading?: boolean;
  secondDiv?: string;
}

const SelectHookFormMulti_1: React.FC<ISelectHookForm> = ({
  field,
  options,
  isDisabled,
  className,
  label,
  onChange,
  value = [],
  isMulti = true,
  isLoading,
  secondDiv = "md:grid-cols-3 items-center",
  isRequired,
}) => {
  return (
    <div className="space-y-1 w-full text-xs">
      <div className={`grid ${secondDiv} w-full items-start gap-1`}>
        {label && (
          <label
            className={`flex items-stretch text-left expandedLabel fontExpand`}
          >
            {isRequired && (
              <span className="text-red-500 font-bold self-start">*</span>
            )}
            {label}:
          </label>
        )}

        <Select
          className={`${
            className ? className : "border border-gray-300 col-span-2"
          } rounded-sm text-xs focus:ring-quaternary focus:border-quaternary  ${
            isDisabled && "opacity-20 "
          }`}
          {...field}
          onChange={onChange}
          value={
            value
              ? value?.find(
                  (x: { value: any }) =>
                    typeof x.value === "string" &&
                    x.value.toUpperCase() === "ALL"
                )
                ? options
                : value
              : null
          }
          options={options}
          isMulti={isMulti}
          isSearchable
          isClearable
          closeMenuOnSelect={false}
          styles={customStyles}
          isDisabled={isDisabled}
          components={
            isMulti
              ? {
                  ValueContainer: valueContainer,
                  MenuList: CustomMenuList,
                }
              : ""
          }
          tabSelectsValue={false}
          isLoading={isLoading}
          //filterOption={createFilter({ ignoreAccents: false })}
        />
      </div>
    </div>
  );
};

export default SelectHookFormMulti_1;
